// 隨螢幕縮放，動態計算Banner中Video的高度
function cm_banner_video_dynamic_size() {
    const movieList = document.querySelectorAll(".carousel-item > .carousel-movie");
    if (movieList.length > 0) {
        let width = document.querySelector(".carousel-item.active").offsetWidth;
        let height = width / 16 * 9;
        for (let i = 0; i < movieList.length; i++) {
            movieList[i].width = width;
            movieList[i].height = height;
            movieList[i].parentElement.style.height = height + "px";
        }
    }
}

export { cm_banner_video_dynamic_size }
